module.exports = __webpack_public_path__ + "img/sakuya izayoi lunar war servant.9772fa36.png";